import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

const gaCode = () =>
  typeof window !== 'undefined'
    ? window?.env?.RAZZLE_GA_CODE || process.env.RAZZLE_GA_CODE
    : process.env.RAZZLE_GA_CODE;

const ga4Code = () =>
  typeof window !== 'undefined'
    ? window?.env?.RAZZLE_GA4_CODE || process.env.RAZZLE_GA4_CODE
    : process.env.RAZZLE_GA4_CODE;

const useAnalyticsPageview = () => {
  const location = useLocation();

  useEffect(() => {
    const page = `${location.pathname}${location.search || ''}`;

    if (gaCode()) {
      ReactGA.pageview(page);
    }

    if (ga4Code()) {
      ReactGA4.send({ hitType: 'pageview', page });
    }
  }, [location.pathname, location.search]);
};

export default useAnalyticsPageview;
